/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Apikey_Generate1Inputs */

const id_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasilkan Kunci`)
};

const ms_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Janakan Kunci`)
};

const da_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generér Nøgle`)
};

const de_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel generieren`)
};

const en_us2_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Key`)
};

const es_es2_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar clave`)
};

const es_mx2_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar Key`)
};

const fil_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-generate ang Key`)
};

const fr_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer la clé`)
};

const it_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera chiave`)
};

const hu_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulcs generálása`)
};

const nl_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleutel genereren`)
};

const no_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer nøkkel`)
};

const pl_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygeneruj klucz`)
};

const pt_br2_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Key`)
};

const pt_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar chave`)
};

const ro_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generează cheia`)
};

const fi_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo avain`)
};

const sv_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera nyckel`)
};

const vi_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo khóa`)
};

const tr_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anahtar Oluştur`)
};

const cs_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generovat klíč`)
};

const bg_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генериране на ключ`)
};

const ru_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сгенерировать ключ`)
};

const uk_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Згенерувати ключ`)
};

const ar_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء مفتاح`)
};

const hi_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजी उत्पन्न करें`)
};

const th_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างคีย์`)
};

const ja_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーを生成`)
};

const zh_cn2_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Key`)
};

const zh_hant1_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Key`)
};

const ko_notifications_apikey_generate1 = /** @type {(inputs: Notifications_Apikey_Generate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Key`)
};

/**
* | output |
* | --- |
* | "Generate Key" |
*
* @param {Notifications_Apikey_Generate1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_apikey_generate1 = /** @type {((inputs?: Notifications_Apikey_Generate1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Apikey_Generate1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_apikey_generate1(inputs)
	if (locale === "ms") return ms_notifications_apikey_generate1(inputs)
	if (locale === "da") return da_notifications_apikey_generate1(inputs)
	if (locale === "de") return de_notifications_apikey_generate1(inputs)
	if (locale === "en-US") return en_us2_notifications_apikey_generate1(inputs)
	if (locale === "es-ES") return es_es2_notifications_apikey_generate1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_apikey_generate1(inputs)
	if (locale === "fil") return fil_notifications_apikey_generate1(inputs)
	if (locale === "fr") return fr_notifications_apikey_generate1(inputs)
	if (locale === "it") return it_notifications_apikey_generate1(inputs)
	if (locale === "hu") return hu_notifications_apikey_generate1(inputs)
	if (locale === "nl") return nl_notifications_apikey_generate1(inputs)
	if (locale === "no") return no_notifications_apikey_generate1(inputs)
	if (locale === "pl") return pl_notifications_apikey_generate1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_apikey_generate1(inputs)
	if (locale === "pt") return pt_notifications_apikey_generate1(inputs)
	if (locale === "ro") return ro_notifications_apikey_generate1(inputs)
	if (locale === "fi") return fi_notifications_apikey_generate1(inputs)
	if (locale === "sv") return sv_notifications_apikey_generate1(inputs)
	if (locale === "vi") return vi_notifications_apikey_generate1(inputs)
	if (locale === "tr") return tr_notifications_apikey_generate1(inputs)
	if (locale === "cs") return cs_notifications_apikey_generate1(inputs)
	if (locale === "bg") return bg_notifications_apikey_generate1(inputs)
	if (locale === "ru") return ru_notifications_apikey_generate1(inputs)
	if (locale === "uk") return uk_notifications_apikey_generate1(inputs)
	if (locale === "ar") return ar_notifications_apikey_generate1(inputs)
	if (locale === "hi") return hi_notifications_apikey_generate1(inputs)
	if (locale === "th") return th_notifications_apikey_generate1(inputs)
	if (locale === "ja") return ja_notifications_apikey_generate1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_apikey_generate1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_apikey_generate1(inputs)
	return ko_notifications_apikey_generate1(inputs)
});
export { notifications_apikey_generate1 as "notifications.apiKey.generate" }